import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import AcademicPeriodForm from 'components/organisms/forms/AcademicPeriodForm'

import { crudActionsMap } from 'utils/helpers'

const AcademicPeriodCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('school.academic-periods')} / ${t('common.' + action)}`} />
      <PageBody>
        <AcademicPeriodForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default AcademicPeriodCrudPage
